import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
   if (isRejectedWithValue(action) && !action.type.startsWith('importAttempts/api/')) {
      const endpoint = (action.meta as { arg?: { endpointName?: string } })?.arg?.endpointName;
      if (endpoint === 'uploadInvoices') return next(action);
      const message = (action.payload as { data?: { message?: string } })?.data?.message;
      if (message) {
         toast.error(message);
      }
   }

   return next(action);
};
